@if (isLoading()) {
  <app-shimmer-effect />
} @else {
  <section class="page-heading">
    <div>
      <h4>{{ (class()?.payload?.level_name) + (class()?.payload?.name ?? 'N/A') }}</h4>
      <small>See details of {{ class()?.payload?.level_name }} {{ class()?.payload?.name }}</small>
    </div>

    <div class="btn-container">

      @if (admins.includes(loggedUserRole ?? '')) {
        <button (click)="showAddStudent.set(true)" class="button first-button">
          <svg width="20" height="17" viewBox="0 0 20 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M3.2454 13.7615C2.98239 13.6067 2.77079 13.3927 2.6106 13.1195C2.4504 12.8464 2.37031 12.54 2.37031 12.2003V7.42624L0.466189 6.33772C0.315003 6.24613 0.199459 6.13636 0.119558 6.00842C0.0398525 5.88048 0 5.73837 0 5.58211C0 5.42564 0.0398525 5.28284 0.119558 5.15369C0.199459 5.02434 0.315003 4.91387 0.466189 4.82228L8.67458 0.197038C8.81069 0.12915 8.94669 0.0793375 9.0826 0.0476027C9.21852 0.0158679 9.36128 0 9.5109 0C9.66052 0 9.80319 0.0158679 9.9389 0.0476027C10.0748 0.0793375 10.2061 0.128948 10.3328 0.196435L19.5488 5.31969C19.6884 5.40988 19.7986 5.52356 19.8793 5.66074C19.9598 5.79813 20 5.94636 20 6.10543V12.7351C20 12.8795 19.9519 13.0006 19.8558 13.0984C19.7596 13.196 19.6405 13.2449 19.4986 13.2449C19.3564 13.2449 19.2387 13.196 19.1455 13.0984C19.0524 13.0006 19.0059 12.8795 19.0059 12.7351V6.1687L16.6512 7.42624V12.2003C16.6512 12.54 16.5711 12.8464 16.4109 13.1195C16.2507 13.3927 16.0341 13.6067 15.7611 13.7615L10.3378 16.7822C10.2078 16.8641 10.0748 16.9209 9.9389 16.9524C9.80319 16.9841 9.66052 17 9.5109 17C9.36128 17 9.21852 16.9841 9.0826 16.9524C8.94669 16.9209 8.80873 16.8641 8.6687 16.7822L3.2454 13.7615ZM9.23976 10.1194C9.33514 10.181 9.42669 10.2119 9.51442 10.2119C9.60236 10.2119 9.6991 10.181 9.80465 10.1194L17.9032 5.58L9.80465 1.09334C9.6991 1.03148 9.60236 1.00055 9.51442 1.00055C9.42669 1.00055 9.33514 1.03148 9.23976 1.09334L1.12743 5.58L9.23976 10.1194ZM9.21714 15.9386C9.31252 16.0005 9.40789 16.0314 9.50326 16.0314C9.59863 16.0314 9.6991 16.0005 9.80465 15.9386L15.3181 12.8517C15.4386 12.7848 15.5252 12.6985 15.5781 12.5929C15.6308 12.4872 15.6571 12.3572 15.6571 12.2027V8.03031L10.3402 10.9853C10.2101 11.0568 10.0768 11.1084 9.94007 11.1401C9.80358 11.1718 9.66052 11.1877 9.5109 11.1877C9.36128 11.1877 9.21891 11.1718 9.08378 11.1401C8.94865 11.1084 8.81607 11.0568 8.68604 10.9853L3.36467 8.0056V12.2027C3.36467 12.3367 3.39101 12.4616 3.44369 12.5775C3.49637 12.6934 3.58293 12.7848 3.70337 12.8517L9.21714 15.9386Z"
              fill="white" />
          </svg>

          <p>Add a student</p>
        </button>

      }

      @if (classStudents()?.payload?.length) {
        <button class="secondary-button" (click)="navigateToAttendancePage()">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.24902 6.41561L6.99871 8.1653L12.831 2.33301" stroke="white" stroke-width="1.2831" />
            <path
              d="M12.2478 6.99882V11.0814C12.2478 11.3908 12.1249 11.6875 11.9061 11.9062C11.6874 12.125 11.3907 12.2479 11.0813 12.2479H2.91609C2.60673 12.2479 2.31003 12.125 2.09128 11.9062C1.87253 11.6875 1.74963 11.3908 1.74963 11.0814V2.91621C1.74963 2.60685 1.87253 2.31016 2.09128 2.0914C2.31003 1.87265 2.60673 1.74976 2.91609 1.74976H9.33161"
              stroke="white" stroke-width="1.2831" />
          </svg>

          <p>Attendance</p>
        </button>
      }

    </div>
  </section>

  <section class="class-container">
    <div class="box-one">
      <div class="class-details">
        <div class="heading">
          <div>
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_29_115)">
                <path
                  d="M18.3333 8.33341V13.3334M18.3333 8.33341L9.99999 4.16675L1.66666 8.33341L9.99999 12.5001L18.3333 8.33341Z"
                  stroke="white" stroke-width="1.41667" />
                <path d="M5 10V14.1667C7.5 16.6667 12.5 16.6667 15 14.1667V10" stroke="white" stroke-width="1.41667" />
              </g>
              <defs>
                <clipPath id="clip0_29_115">
                  <rect width="20" height="20" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <small>Level</small>

          <h4>{{ (class()?.payload?.level_name) + (class()?.payload?.name ?? 'N/A') }}</h4>

          <small>{{ class()?.payload?.public_id }}</small>
        </div>

        <div class="class-numbers">
          <div>
            <small>Class Teacher</small>
            @if (class()?.payload?.class_teacher_id; as classTeacherId) {
              <button type="button" class="student-link"
                      (click)="navigateToTeacherDetail(classTeacherId)">
                {{ (class()?.payload?.class_teacher_first_name ?? '') + ' ' + (class()?.payload?.class_teacher_last_name ?? '') }}
              </button>
            } @else {
              <h6>None Assigned</h6>
            }
          </div>

          <div>
            <small>Academic Year</small>
            <h6>{{ class()?.payload?.academic_year_name }}</h6>
          </div>

          <div>
            <small>Total Students</small>
            <h6>{{ dashboardData()?.totalStudents ?? '0' }}</h6>
          </div>

          <div>
            <small>Status</small>
            <h6 [ngClass]="class()?.payload?.status" class="class-status">{{ class()?.payload?.status }}</h6>
          </div>
        </div>

      </div>

      <div class="gender-split">
        <h6>Gender Split</h6>

        <div
          [style.background]="(dashboardData()?.maleStudents === 0) && (dashboardData()?.femaleStudents === 0) ? '#d9d9d9' : '#DB2777'"
          class="gender-range">
          <div [style.width.%]="malePercentage()"></div>
        </div>

        <ul>
          <li>
            <span class="male"></span>
            <small>Male</small>
            <small class="male-number">{{ dashboardData()?.maleStudents ?? 0 }}</small>
          </li>

          <li>
            <span class="female"></span>
            <small>Female</small>
            <small class="female-number">{{ dashboardData()?.femaleStudents ?? 0 }}</small>
          </li>
        </ul>

      </div>

      <div class="subjects-box">
        <div class="heading">
          <h6>Subjects</h6>

          <p>{{ dashboardData()?.totalSubjects ?? 0 }}</p>
        </div>

        @if (dashboardData()?.subjects?.length) {
          <ul>
            @for (s of dashboardData()?.subjects; track s.id) {
              <li>
                <h6>{{ s.name }}</h6>

                <h6 class="subject-status" [ngClass]="s.status">{{ s.status }}</h6>
              </li>
            }
          </ul>
        }

      </div>

      @if (admins.includes(loggedUserRole ?? '')) {
        <div class="action-btns">
          <button (click)="openAssignSubjectTeacher()" class="button">Assign Subject Teacher</button>

          <button (click)="openAssignClassTeacher()" class="secondary-button">Assign Class Teacher</button>
        </div>
      }

    </div>

    <div class="box-two">
      <section class="table-content">

        <div class="class-subject-heading">
          <div class="icon">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_39_211)">
                <path
                  d="M11.9117 5.41448V8.66313M11.9117 5.41448L6.4973 2.70728L1.08288 5.41448L6.4973 8.12169L11.9117 5.41448Z"
                  stroke="#5C0B13" stroke-width="0.974595" />
                <path d="M3.24865 6.49731V9.20452C4.87297 10.8288 8.12162 10.8288 9.74595 9.20452V6.49731"
                      stroke="#5C0B13" stroke-width="0.974595" />
              </g>
              <defs>
                <clipPath id="clip0_39_211">
                  <rect width="12.9946" height="12.9946" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div>
            <h6>Students</h6>
            <small>{{ classStudents()?.payload?.length }} student(s) enrolled
              in {{ (class()?.payload?.level_name) + (class()?.payload?.name ?? 'N/A') }}</small>
          </div>

          <div class="filters">
            <div>
              <input (input)="getClassStudents('search', searchStudent)" [(ngModel)]="searchStudent" name="searchStudent" type="text" placeholder="Search Student...">

              <select (change)="getClassStudents('academic_year_id', filterAcademicYear)" [(ngModel)]="filterAcademicYear"
                      name="status" id="status">
                <option value="">Select an academic year</option>

                @for (a of academicYears()?.payload; track a.id) {
                  <option [value]="a.id">{{ a.name }}</option>
                }
              </select>
            </div>
          </div>
        </div>

        <div class="table-wrapper">
          <table>
            <thead>
            <tr>
              <th>STUDENT ID</th>
              <th>FULL NAME</th>
              <th>ACADEMIC YEAR</th>
              <th>DATE ENROLLED</th>
              <th>STATUS</th>

              @if (admins.includes(loggedUserRole ?? '')) {
                <th class="options-column">ACTIONS</th>
              }
            </tr>
            </thead>

            <tbody>
              @if (isFiltering()) {
                <td colspan="6">
                  <app-loading-indicator />
                </td>
              } @else {
                @if (!classStudents()?.payload?.length) {
                  @if (admins.includes(loggedUserRole ?? '')) {
                    <tr>
                      <td colspan="6" class="empty">
                        <app-not-found-error>
                          NO STUDENTS FOUND
                        </app-not-found-error>
                      </td>
                    </tr>
                  } @else {
                    <tr>
                      <td colspan="5" class="empty">
                        <app-not-found-error>
                          NO STUDENTS FOUND
                        </app-not-found-error>
                      </td>
                    </tr>
                  }
                } @else {
                  @for (u of classStudents()?.payload; track u.id) {
                    <tr>
                      <td>
                        {{ u.student_public_id }}
                      </td>

                      <td>
                        <button type="button" class="student-link"
                                (click)="navigateToStudentDetail(u.student_id)">
                          {{ Helpers.fullName({ first_name: u.student_last_name, last_name: u.student_first_name }) }}
                        </button>
                      </td>

                      <td>
                        {{ u.academic_year_name }}
                      </td>

                      <td>
                        {{ Helpers.formatDate(u.enrollment_date) }}
                      </td>

                      <td class="status">
                        <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                      </td>

                      @if (admins.includes(loggedUserRole ?? '')) {
                        <td class="options-column">
                          <app-action-button>
                            <button type="button" class="menu-item" (click)="navigateToStudentDetail(u.student_id)">View
                              Details
                            </button>
                            <button type="button" class="menu-item" (click)="openReportCard(u)">Report
                              card
                            </button>
                            <button type="button" class="menu-item" (click)="selectStudentEnrolled('edit', u)">Update
                              enrollment
                            </button>

                            @if (!u.current_enrollment) {
                              <button type="button" class="menu-item" (click)="selectStudentEnrolled('status', u)">
                                Change
                                status
                              </button>
                            }
                          </app-action-button>
                        </td>
                      }
                    </tr>
                  }
                }
              }
            </tbody>
          </table>
        </div>

        <app-pagination
          [page]="classStudents()?.pagination?.page ?? 0"
          [size]="classStudents()?.pagination?.size ?? 10"
          [totalElements]="classStudents()?.pagination?.totalElements ?? 0"
          [totalPages]="classStudents()?.pagination?.totalPages ?? 0"
          [first]="classStudents()?.pagination?.first ?? true"
          [last]="classStudents()?.pagination?.last ?? false"
          [hasNext]="classStudents()?.pagination?.hasNext ?? false"
          [hasPrevious]="classStudents()?.pagination?.hasPrevious ?? false"
          (pageChange)="loadStudentsPage($event)">
        </app-pagination>

      </section>

      <section class="table-content">

        <div class="class-subject-heading">
          <div class="icon">
            <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_39_211)">
                <path
                  d="M11.9117 5.41448V8.66313M11.9117 5.41448L6.4973 2.70728L1.08288 5.41448L6.4973 8.12169L11.9117 5.41448Z"
                  stroke="#5C0B13" stroke-width="0.974595" />
                <path d="M3.24865 6.49731V9.20452C4.87297 10.8288 8.12162 10.8288 9.74595 9.20452V6.49731"
                      stroke="#5C0B13" stroke-width="0.974595" />
              </g>
              <defs>
                <clipPath id="clip0_39_211">
                  <rect width="12.9946" height="12.9946" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>

          <div>
            <h6>Subject Teachers</h6>
            <small>{{ dashboardData()?.totalSubjects ?? 0 }} subject(s) assigned
              to {{ (class()?.payload?.level_name) + (class()?.payload?.name ?? 'N/A') }}</small>
          </div>

        </div>

        <div class="table-wrapper">
          <table>
            <thead>
            <tr>
              <th>SUBJECT</th>
              <th>SUBJECT CODE</th>
              <th>ASSIGNED TEACHER</th>
              <th>TEACHER ROLE</th>
              <th>STAFF NUMBER</th>
              <th class="options-column">ACTIONS</th>
            </tr>
            </thead>

            <tbody>
              @if (isFiltering()) {
                <td colspan="6">
                  <app-loading-indicator />
                </td>
              } @else {
                @if (!teacherClassSubjects()?.payload?.length) {
                  <tr>
                    <td colspan="6" class="empty">
                      <app-not-found-error>
                        NO SUBJECT TEACHERS FOUND
                      </app-not-found-error>
                    </td>
                  </tr>

                } @else {
                  @for (u of teacherClassSubjects()?.payload; track u.id) {
                    <tr>
                      <td>
                        {{ u.subject_name }}
                      </td>

                      <td>
                        {{ u.subject_code }}
                      </td>

                      <td>
                        <button type="button" class="student-link"
                                (click)="navigateToTeacherDetail(u.teacher_id)">
                          {{ Helpers.fullName({ first_name: u.teacher_first_name, last_name: u.teacher_last_name }) }}
                        </button>
                      </td>

                      <td class="role">
                        <p [ngClass]="u.assignment_role">{{ u.assignment_role }}</p>
                      </td>

                      <td>
                        {{ u.staff_number }}
                      </td>

                      @if ((loggedUserId === u.user_id) || loggedUserRole === 'SCHOOL_ADMIN') {
                        <td class="options-column">
                        <app-action-button>
                          <button type="button" class="menu-item"
                                  (click)="navigateToTakeAssessment(u.class_id, u.level_subject_id)">
                            Take Assessment
                          </button>
                        </app-action-button>
                      </td>
                      }
                    </tr>
                  }
                }
              }
            </tbody>
          </table>
        </div>

        <app-pagination
          [page]="teacherClassSubjects()?.pagination?.page ?? 0"
          [size]="teacherClassSubjects()?.pagination?.size ?? 10"
          [totalElements]="teacherClassSubjects()?.pagination?.totalElements ?? 0"
          [totalPages]="teacherClassSubjects()?.pagination?.totalPages ?? 0"
          [first]="teacherClassSubjects()?.pagination?.first ?? true"
          [last]="teacherClassSubjects()?.pagination?.last ?? false"
          [hasNext]="teacherClassSubjects()?.pagination?.hasNext ?? false"
          [hasPrevious]="teacherClassSubjects()?.pagination?.hasPrevious ?? false"
          (pageChange)="loadSubjectsPage($event)">
        </app-pagination>

      </section>
    </div>
  </section>

}

@if (showAddStudent()) {
  <section class="pop-up">
    <div class="bg" (click)="showAddStudent.set(false)"></div>

    <form #studentForm="ngForm" (ngSubmit)="addStudent(studentForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>

        <div>
          <h6>Assign a student to this class</h6>
          <small>Student will belong to this class</small>
        </div>
      </div>

      <div class="form-container">
        <div class="user-query">
          <label for="query">Search Student <span class="required-check">*</span></label>
          <input (input)="getStudents(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search for a student...">

          @if (students()?.payload?.length && query !== '') {
            <ul>

              @for (student of students()?.payload; track student.id) {
                @if (!invalidStatuses.includes(student.status)) {
                  <li (click)="selectStudent(student)">
                    <h6>{{ Helpers.fullName({ first_name: student.first_name, last_name: student.last_name }) }}</h6>
                    <p>Username: {{ student.public_id }}</p>
                  </li>
                }
              }

            </ul>
          }
        </div>

        @if (studentPublicId && studentPublicId !== '') {
          <div class="user-card">
            <div class="heading">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
                  stroke="white" stroke-width="1.37352" />
                <path
                  d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
                  stroke="white" stroke-width="1.37352" />
              </svg>
              <h4>Selected Student</h4>
            </div>

            <div class="user-content">
              <p>STUDENT ID</p>
              <p>STUDENT NAME</p>

              <h5>{{ studentPublicId }}</h5>
              <h5>{{ studentName }}</h5>
            </div>
          </div>
        }

        <div>
          <label for="academicYearId">Academic Year <span class="required-check">*</span></label>
          <select (change)="onAcademicYearChange()" required [(ngModel)]="academicYearId" name="academicYearId"
                  id="academicYearId">
            <option value="">Select an academic year</option>

            @for (a of academicYears()?.payload; track a.id) {
              <option [value]="a.id">{{ a.name }}</option>
            }
          </select>
        </div>

        <div>
          <label for="startDate">Start Date <span class="required-check">*</span></label>
          <input required [disabled]="academicYear() !== null" [(ngModel)]="startDate" type="date" name="startDate"
                 id="startDate">
        </div>

        <div>
          <label for="endDate">End Date <span class="required-check">*</span></label>
          <input required [disabled]="academicYear() !== null" [(ngModel)]="endDate" type="date" name="endDate"
                 id="endDate">
        </div>

        <div>
          <label for="enrollmentDate">Date Enrolled <span class="required-check">*</span></label>
          <input required [(ngModel)]="enrollmentDate" type="date" name="enrollmentDate" id="enrollmentDate">
        </div>

        @if (academicYear() !== null) {
          <div class="note">

            <div class="shield-box"><img src="/auth/warning-icon.png" alt="warning image"></div>

            <div>
              <p>Start & End dates must fall strictly within the boundaries of the parent Academic Year
                ({{ Helpers.formatDate(academicYear()?.payload?.start_date) }}
                - {{ Helpers.formatDate(academicYear()?.payload?.end_date) }}).</p>
            </div>
          </div>
        }

        <button [disabled]="studentForm.invalid" class="secondary-button" type="submit">
          @if (isSubmitting()) {
            <app-loading-indicator />
          } @else {
            Assign Student
          }
        </button>

      </div>
    </form>
  </section>
}

@if (changeStatus()) {
  <section class="pop-up">
    <div class="bg" (click)="changeStatus.set(false)"></div>

    <form #changeStatusForm="ngForm" (ngSubmit)="changeStudentStatus(changeStatusForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_42_378)">
              <path
                d="M8.99465 16.49C13.1343 16.49 16.4901 13.1342 16.4901 8.99452C16.4901 4.85487 13.1343 1.49902 8.99465 1.49902C4.855 1.49902 1.49915 4.85487 1.49915 8.99452C1.49915 13.1342 4.855 16.49 8.99465 16.49Z"
                stroke="#5C0B13" stroke-width="1.34919" />
              <path d="M8.99463 4.49731V8.99461L11.9928 10.4937" stroke="#5C0B13" stroke-width="1.34919" />
            </g>
            <defs>
              <clipPath id="clip0_42_378">
                <rect width="17.9892" height="17.9892" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>
        <div>
          <h6>Change Status</h6>
          <small>Select a new status</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="newStatus">New Status <span class="required-check">*</span></label>
          <select required [(ngModel)]="newStatus" name="newStatus" id="newStatus">
            <option value="" hidden disabled>Select a status</option>

            @for (s of validStatuses; track $index) {
              @if (s !== currentStatus) {
                <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
              }
            }
          </select>

        </div>

        <button class="button" [disabled]="changeStatusForm.invalid" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Change status
          }
        </button>

      </div>

    </form>
  </section>
}

@if (editEnrollment()) {
  <section class="pop-up">
    <div
      class="bg"
      (click)="editEnrollment.set(false)">
    </div>

    <form #studentEnrollmentForm="ngForm" (ngSubmit)="editStudentEnrollment(studentEnrollmentForm)">

      <div class="form-heading">
        <div class="image-box">
          <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">

            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white"
              stroke-width="1.37352"
            />

            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white"
              stroke-width="1.37352"
            />
          </svg>
        </div>

        <div>
          <h6>Edit Student Enrollment</h6>
          <small>Update the student's enrollment information</small>
        </div>
      </div>

      <div class="form-container">

        <div>
          <label for="enrollmentDate">Date Enrolled <span class="required-check">*</span></label>

          <input
            required
            [(ngModel)]="enrollmentDate"
            type="date"
            name="enrollmentDate"
            id="enrollmentDate"
          />
        </div>

        <div>
          <label for="startDate">Start Date <span class="required-check">*</span></label>

          <input
            required
            [(ngModel)]="startDate"
            type="date"
            name="startDate"
            id="startDate"
          />
        </div>

        <div>
          <label for="endDate">End Date <span class="required-check">*</span></label>

          <input
            required
            [(ngModel)]="endDate"
            type="date"
            name="endDate"
            id="endDate"
          />
        </div>

        <div class="checkbox">
          <input
            [(ngModel)]="currentEnrollment"
            type="checkbox"
            name="currentEnrollment"
            id="currentEnrollment"
          />

          <label for="currentEnrollment">
            Set as current enrollment
          </label>
        </div>

        @if (academicYear() !== null) {
          <div class="note">

            <div class="shield-box"><img src="/auth/warning-icon.png" alt="warning image"></div>

            <div>
              <p>Start & End dates must fall strictly within the boundaries of the parent Academic Year
                ({{ Helpers.formatDate(academicYear()?.payload?.start_date) }}
                - {{ Helpers.formatDate(academicYear()?.payload?.end_date) }}).</p>
            </div>
          </div>
        }

        <button
          [disabled]="studentEnrollmentForm.invalid || isSubmitting()"
          class="secondary-button"
          type="submit">

          @if (isSubmitting()) {
            <app-loading-indicator />
          } @else {
            Update Enrollment
          }

        </button>

      </div>
    </form>
  </section>
}

@if (assignClassTeacher()) {
  <section class="pop-up">
    <div class="bg" (click)="assignClassTeacher.set(false)"></div>

    <form #classTeacherForm="ngForm" (ngSubmit)="assignClassTeacherFn(classTeacherForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>

        <div>
          <h6>Assign a Class Teacher</h6>
          <small>Teachers can be assigned to classes or subjects</small>
        </div>
      </div>

      <div class="form-container">
        <div class="user-query">
          <label for="query">Search Class Teacher <span class="required-check">*</span></label>
          <input (input)="getTeachers(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search name, staff id or username...">

          @if (teachers()?.payload?.length && query !== '') {
            <ul>

              @for (t of teachers()?.payload; track t.id) {
                @if (!invalidStatuses.includes(t.status)) {
                  <li (click)="selectTeacher(t)">
                    <h6>{{
                        Helpers.fullName({
                          first_name: t.first_name,
                          last_name: t.last_name,
                        })
                      }}
                    </h6>
                    <p>Teacher ID: {{ t.public_id }}</p>
                  </li>
                }
              }

            </ul>
          }
        </div>

        @if (teacherName) {
          <div class="user-card">
            <div class="heading">
              <svg fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"><title>school</title>
                  <path
                    d="M30 21.25h-6.25v-8.957l5.877 3.358c0.107 0.062 0.236 0.098 0.373 0.099h0c0.414-0.001 0.749-0.336 0.749-0.751 0-0.277-0.15-0.519-0.373-0.649l-0.004-0.002-13.623-7.784v-0.552c0.172 0.016 0.35 0.068 0.519 0.068 0.004 0 0.010 0 0.015 0 0.475 0 0.934-0.067 1.368-0.193l-0.035 0.009c0.323-0.063 0.693-0.099 1.073-0.099 0.392 0 0.775 0.039 1.146 0.112l-0.037-0.006c0.039 0.007 0.083 0.012 0.129 0.012 0.184 0 0.352-0.068 0.479-0.181l-0.001 0.001c0.161-0.139 0.263-0.343 0.264-0.571v-2.812c0 0 0-0 0-0 0-0.355-0.247-0.653-0.579-0.73l-0.005-0.001c-0.419-0.111-0.9-0.176-1.396-0.176-0.5 0-0.985 0.065-1.446 0.187l0.039-0.009c-0.288 0.067-0.618 0.105-0.958 0.105-0.231 0-0.457-0.018-0.678-0.052l0.025 0.003c-0.122-0.256-0.378-0.43-0.676-0.43-0.412 0-0.746 0.334-0.746 0.746 0 0.001 0 0.003 0 0.004v-0 4.565l-13.622 7.784c-0.227 0.132-0.378 0.374-0.378 0.651 0 0.414 0.336 0.75 0.75 0.75 0.137 0 0.265-0.037 0.376-0.101l-0.004 0.002 5.878-3.359v8.957h-6.25c-0.414 0-0.75 0.336-0.75 0.75v0 8c0 0.414 0.336 0.75 0.75 0.75h28c0.414-0 0.75-0.336 0.75-0.75v0-8c-0-0.414-0.336-0.75-0.75-0.75v0zM18.658 3.075c0.298-0.082 0.64-0.13 0.993-0.13 0.183 0 0.363 0.013 0.539 0.037l-0.020-0.002v1.339c-0.16-0.013-0.345-0.021-0.533-0.021-0.489 0-0.966 0.052-1.425 0.151l0.044-0.008c-0.304 0.088-0.653 0.139-1.014 0.139-0.174 0-0.344-0.012-0.512-0.034l0.020 0.002v-1.323c0.15 0.014 0.325 0.021 0.502 0.021 0.499 0 0.984-0.062 1.447-0.18l-0.041 0.009zM2.75 22.75h5.5v6.5h-5.5zM9.75 22v-10.564l6.25-3.571 6.25 3.572v17.814h-2.5v-5.25c-0-0.414-0.336-0.75-0.75-0.75h-6c-0.414 0-0.75 0.336-0.75 0.75v0 5.25h-2.5zM13.75 29.25v-4.5h4.5v4.5zM29.25 29.25h-5.5v-6.5h5.5zM16 19.75c2.071 0 3.75-1.679 3.75-3.75s-1.679-3.75-3.75-3.75c-2.071 0-3.75 1.679-3.75 3.75v0c0.002 2.070 1.68 3.748 3.75 3.75h0zM16 13.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25c-1.243 0-2.25-1.007-2.25-2.25v0c0.002-1.242 1.008-2.248 2.25-2.25h0z"></path>
                </g>
              </svg>
              <h4>Selected Teacher</h4>
            </div>

            <div class="user-content">
              <p>TEACHER NAME</p>
              <p>TEACHER ID</p>

              <h5>{{ teacherName }}</h5>
              <h5>{{ teacherPublicId }}</h5>
            </div>
          </div>
        }

        <button [disabled]="classTeacherForm.invalid || !classTeacherId" class="button" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Assign Class Teacher
          }
        </button>

      </div>

    </form>
  </section>
}

@if (assignSubjectTeacherCheck()) {
  <section class="pop-up">
    <div class="bg" (click)="assignSubjectTeacherCheck.set(false)"></div>

    <form #subjectTeacherForm="ngForm" (ngSubmit)="assignSubjectTeacher(subjectTeacherForm)">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12.4865 13.1108V11.8622C12.4865 11.1998 12.2234 10.5646 11.7551 10.0963C11.2867 9.62798 10.6515 9.36487 9.98921 9.36487H4.99461C4.33229 9.36487 3.69709 9.62798 3.22876 10.0963C2.76042 10.5646 2.49731 11.1998 2.49731 11.8622V13.1108"
              stroke="white" stroke-width="1.37352" />
            <path
              d="M7.49193 6.86759C8.87115 6.86759 9.98923 5.74951 9.98923 4.37029C9.98923 2.99107 8.87115 1.87299 7.49193 1.87299C6.11271 1.87299 4.99463 2.99107 4.99463 4.37029C4.99463 5.74951 6.11271 6.86759 7.49193 6.86759Z"
              stroke="white" stroke-width="1.37352" />
          </svg>
        </div>

        <div>
          <h6>Assign a Subject Teacher</h6>
          <small>Teachers can be assigned to classes or subjects</small>
        </div>
      </div>

      <div class="form-container">
        <div>
          <label for="levelSubjectId">Subject <span class="required-check">*</span></label>
          <select required [(ngModel)]="selectedLevelSubject" name="levelSubjectId" id="levelSubjectId">
            <option [ngValue]="undefined" disabled>Select a subject</option>

            @for (ls of levelSubjects()?.payload; track ls.id) {
              <option [ngValue]="ls">{{ ls.subject_name }} ({{ ls.subject_code }})</option>
            }
          </select>
        </div>

        <div class="user-query">
          <label for="query">Search Class Teacher <span class="required-check">*</span></label>
          <input (input)="getTeachers(query)" [(ngModel)]="query" type="search" name="query" id="query"
                 placeholder="Search name, staff id or username...">

          @if (teachers()?.payload?.length && query !== '') {
            <ul>

              @for (t of teachers()?.payload; track t.id) {
                @if (!invalidStatuses.includes(t.status)) {
                  <li (click)="selectTeacher(t)">
                    <h6>{{
                        Helpers.fullName({
                          first_name: t.first_name,
                          last_name: t.last_name,
                        })
                      }}
                    </h6>
                    <p>Teacher ID: {{ t.public_id }}</p>
                  </li>
                }
              }

            </ul>
          }
        </div>

        @if (teacherName) {
          <div class="user-card">
            <div class="heading">
              <svg fill="#fff" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier"><title>school</title>
                  <path
                    d="M30 21.25h-6.25v-8.957l5.877 3.358c0.107 0.062 0.236 0.098 0.373 0.099h0c0.414-0.001 0.749-0.336 0.749-0.751 0-0.277-0.15-0.519-0.373-0.649l-0.004-0.002-13.623-7.784v-0.552c0.172 0.016 0.35 0.068 0.519 0.068 0.004 0 0.010 0 0.015 0 0.475 0 0.934-0.067 1.368-0.193l-0.035 0.009c0.323-0.063 0.693-0.099 1.073-0.099 0.392 0 0.775 0.039 1.146 0.112l-0.037-0.006c0.039 0.007 0.083 0.012 0.129 0.012 0.184 0 0.352-0.068 0.479-0.181l-0.001 0.001c0.161-0.139 0.263-0.343 0.264-0.571v-2.812c0 0 0-0 0-0 0-0.355-0.247-0.653-0.579-0.73l-0.005-0.001c-0.419-0.111-0.9-0.176-1.396-0.176-0.5 0-0.985 0.065-1.446 0.187l0.039-0.009c-0.288 0.067-0.618 0.105-0.958 0.105-0.231 0-0.457-0.018-0.678-0.052l0.025 0.003c-0.122-0.256-0.378-0.43-0.676-0.43-0.412 0-0.746 0.334-0.746 0.746 0 0.001 0 0.003 0 0.004v-0 4.565l-13.622 7.784c-0.227 0.132-0.378 0.374-0.378 0.651 0 0.414 0.336 0.75 0.75 0.75 0.137 0 0.265-0.037 0.376-0.101l-0.004 0.002 5.878-3.359v8.957h-6.25c-0.414 0-0.75 0.336-0.75 0.75v0 8c0 0.414 0.336 0.75 0.75 0.75h28c0.414-0 0.75-0.336 0.75-0.75v0-8c-0-0.414-0.336-0.75-0.75-0.75v0zM18.658 3.075c0.298-0.082 0.64-0.13 0.993-0.13 0.183 0 0.363 0.013 0.539 0.037l-0.020-0.002v1.339c-0.16-0.013-0.345-0.021-0.533-0.021-0.489 0-0.966 0.052-1.425 0.151l0.044-0.008c-0.304 0.088-0.653 0.139-1.014 0.139-0.174 0-0.344-0.012-0.512-0.034l0.020 0.002v-1.323c0.15 0.014 0.325 0.021 0.502 0.021 0.499 0 0.984-0.062 1.447-0.18l-0.041 0.009zM2.75 22.75h5.5v6.5h-5.5zM9.75 22v-10.564l6.25-3.571 6.25 3.572v17.814h-2.5v-5.25c-0-0.414-0.336-0.75-0.75-0.75h-6c-0.414 0-0.75 0.336-0.75 0.75v0 5.25h-2.5zM13.75 29.25v-4.5h4.5v4.5zM29.25 29.25h-5.5v-6.5h5.5zM16 19.75c2.071 0 3.75-1.679 3.75-3.75s-1.679-3.75-3.75-3.75c-2.071 0-3.75 1.679-3.75 3.75v0c0.002 2.070 1.68 3.748 3.75 3.75h0zM16 13.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25c-1.243 0-2.25-1.007-2.25-2.25v0c0.002-1.242 1.008-2.248 2.25-2.25h0z"></path>
                </g>
              </svg>
              <h4>Selected Teacher</h4>
            </div>

            <div class="user-content">
              <p>TEACHER NAME</p>
              <p>TEACHER ID</p>

              <h5>{{ teacherName }}</h5>
              <h5>{{ teacherPublicId }}</h5>
            </div>
          </div>
        }

        <div>
          <label for="assignmentRole">Teacher Role <span class="required-check">*</span></label>
          <select required [(ngModel)]="assignmentRole" name="assignmentRole" id="assignmentRole">
            <option value="">Select a role</option>
            <option value="LEAD">Lead</option>
            <option value="ASSISTANT">Assistant</option>
            <option value="SUBSTITUTE">Substitute</option>
          </select>
        </div>

        <button [disabled]="subjectTeacherForm.invalid || !classTeacherId" class="button" type="submit">
          @if (isAssigningSubjectTeacher()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Assign Subject Teacher
          }
        </button>

      </div>

    </form>
  </section>
}

@if (showReportCard()) {
  <section class="pop-up">
    <div class="bg" (click)="showReportCard.set(false)"></div>

    <div class="report-card">
      <div class="form-heading">
        <div class="image-box">
          <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.75 2.5H11.25V12.5H3.75V2.5Z" stroke="white" stroke-width="1.25"/>
            <path d="M5.625 5H9.375M5.625 7.5H9.375M5.625 10H8.125" stroke="white" stroke-width="1.25"
                  stroke-linecap="round"/>
          </svg>
        </div>

        <div>
          <h6>Report Card</h6>
          <small>
            {{ Helpers.fullName({ first_name: reportCardStudent()?.student_last_name, last_name: reportCardStudent()?.student_first_name }) }}
            · {{ academicReport()?.payload?.academic_year?.name ?? reportCardStudent()?.academic_year_name }}
          </small>
        </div>
      </div>

      <div class="form-container">
        <div class="report-card-meta">
          <div>
            <span>STUDENT ID</span>
            <h6>{{ reportCardStudent()?.student_public_id }}</h6>
          </div>

          <div>
            <label for="reportCardTermId">Academic Term</label>
            <select [(ngModel)]="reportCardTermId" (change)="getStudentReport()" name="reportCardTermId"
                    id="reportCardTermId">
              <option value="">All terms</option>

              @for (t of reportCardTerms()?.payload; track t.id) {
                <option [value]="t.id">{{ t.term_name }}</option>
              }
            </select>
          </div>
        </div>

        @if (isLoadingReport()) {
          <app-loading-indicator/>
        } @else if (!academicReport()?.payload?.subjects?.length) {
          <div class="report-card-empty">
            <app-not-found-error>
              NO REPORT CARD RESULTS FOUND
            </app-not-found-error>
            <small>Results appear here once the student's scores have been finalized.</small>
          </div>
        } @else {
          <div class="report-card-summary">
            <div>
              <small>Subjects</small>
              <h6>{{ academicReport()?.payload?.summary?.subject_count }}</h6>
            </div>

            <div>
              <small>Total Score</small>
              <h6>{{ academicReport()?.payload?.summary?.total_score }}</h6>
            </div>

            <div>
              <small>Average</small>
              <h6>{{ academicReport()?.payload?.summary?.average_score }}</h6>
            </div>
          </div>

          <div class="table-wrapper">
            <table class="report-card-table">
              <thead>
              <tr>
                <th>SUBJECT</th>
                <th>TERM</th>
                <th>CLASS SCORE</th>
                <th>EXAM SCORE</th>
                <th>FINAL</th>
                <th>GRADE</th>
                <th>REMARK</th>
                <th>POSITION</th>
              </tr>
              </thead>

              <tbody>
                @for (r of academicReport()?.payload?.subjects; track r.assessment_result_id) {
                  <tr>
                    <td>
                      <h6>{{ r.subject_name }}</h6>
                      <small>{{ r.subject_code }}</small>
                    </td>

                    <td>{{ r.term_name }}</td>

                    <td>
                      {{ r.raw_class_score ?? '-' }}
                      <small>/ {{ r.class_score_maximum ?? '-' }}</small>
                    </td>

                    <td>
                      {{ r.raw_exam_score ?? '-' }}
                      <small>/ {{ r.raw_exam_maximum ?? '-' }}</small>
                    </td>

                    <td class="final-score">{{ r.final_score ?? '-' }}</td>

                    <td>
                      <span class="grade-badge">{{ r.grade ?? '-' }}</span>
                    </td>

                    <td>{{ r.remark ?? '-' }}</td>

                    <td>
                      @if (r.position) {
                        {{ Helpers.numberToPosition(r.position) }}
                        <small>of {{ r.class_size }}</small>
                      } @else {
                        -
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </div>
  </section>
}
